import type { GetNextPageParamFunction } from '@tanstack/react-query';

import type { PaginatedResponse } from './schemas';

interface CreatePaginationQueryOptionsParams {
  take: number;
}

export interface PageParam {
  skip?: number;
  take: number;
}

interface CreatePaginationQueryOptionsResult<TPageParam, TQueryFnData> {
  getNextPageParam: GetNextPageParamFunction<TPageParam, TQueryFnData>;
  initialPageParam: PageParam;
}

export const createPaginationQueryOptions = <
  TQueryFnData extends PaginatedResponse<TData>,
  TData = unknown,
>({
  take,
}: CreatePaginationQueryOptionsParams): CreatePaginationQueryOptionsResult<
  PageParam,
  TQueryFnData
> => ({
  getNextPageParam: (lastPage, _allPages, lastPageParam) => {
    if (lastPage.page === lastPage.totalPages) {
      return null;
    }

    const skip = lastPage.page * lastPageParam.take;

    return { skip, take: lastPageParam.take };
  },
  initialPageParam: { skip: 0, take },
});
